import { render, staticRenderFns } from "./ShowsManipulationsList.vue?vue&type=template&id=1433f1c5&lang=pug&"
import script from "./ShowsManipulationsList.vue?vue&type=script&lang=js&"
export * from "./ShowsManipulationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports